import Color from 'color';
import { useWidgetContext } from 'widget/widget-context';

const useMuted = () => {
  const { widget } = useWidgetContext();

  const { colors } = widget;
  const Muted = Color(colors.primary);

  const ratio = widget.theme == 'dark' ? 0.4 : 0.75;
  const muted = Muted.lighten(ratio).hex();

  if (muted == '#FFFFFF') return colors.primary;
  return muted;
};

export default useMuted;
